module.exports = __webpack_public_path__ + "img/logo-explicae.bb3a99c6.svg";